import {createStyles, WithStyles} from '@material-ui/core';
import {Theme} from 'feedback-system/with-root/typedef';

const drawerWidth = 240;

export const styles = (theme: Theme) => createStyles({
    root: {
        display: 'flex'
    },
    drawer: {
        [theme.breakpoints.up('md')]: {
            width: drawerWidth,
            flexShrink: 0
        }
    },
    drawerHeader: {
        display: 'flex',
        alignItems: 'center',
        padding: '0 8px',
        ...theme.mixins.toolbar,
        justifyContent: 'flex-end'
    },
    appBar: {
        display: 'flex',
        justifyContent: 'space-between',
        zIndex: theme.zIndex.drawer + 1
    },
    logo: {
        textDecoration: 'none',
        [theme.breakpoints.down('sm')]: {
            width: '140px'
        },
        [theme.breakpoints.up('sm')]: {
            width: '220px'
        }
    },
    menuButton: {
        marginRight: 20,
        [theme.breakpoints.up('md')]: {
            display: 'none'
        }
    },
    toolbar: {
        display: 'flex',
        justifyContent: 'space-between',
        ...theme.mixins.toolbar
    },
    drawerPaper: {
        width: drawerWidth
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3)
    }
});

export type Classes = WithStyles<typeof styles>
